<template>
  <div>
    <div id="PengajuanMasuk">
      <div class="row mb-4">
        <div class="col-sm-8">
          <h2>Pengajuan Lending Masuk</h2>
        </div>
        <div class="col-sm-4 text-right">
          <b-button 
            :disabled="isLoading"
            variant="primary" 
            class="btn btn-custom theme-color px-4 rounded-5" 
            @click="downloadPengajuanMasukMitra"
          >
            <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
            <span v-if="!isLoading">Download</span>
          </b-button>
        </div>
      </div>
      <div class="row no-gutters mb-4">
        <div class="col-md-3">
          Search
          <div class="input-group">
            <input type="text" class="form-control mb-2" id="autoSizingInputGroup" placeholder="search..">
            <button class="input-group-text mb-2"><i class="fa fa-search"></i></button>
          </div>
        </div>
      </div>
      <div class="overflow-auto">
        <b-table id="pengajuan-table" responsive="true" :items="pengajuanItems" :fields="pengajuanFields" :current-page="currentPagePengajuan" :per-page="perPagePengajuan">
          <template v-slot:cell(id_transaksi)="data">
            <div>{{ data.item.id }}</div>
          </template>
          <template v-slot:cell(funder)="data">
            <div>{{ data.item.funder.name }}</div>
          </template>
          <template v-slot:cell(product)="data">
            <div>{{ data.item.product.nama_produk }}</div>
          </template>
          <template v-slot:cell(sub_product_category)="data">
            <div>{{ data.item.product.sub_product_category.name }}</div>
          </template>
          <template v-slot:cell(created_at)="data">
            <div>{{ formatTanggal(data.item.created_at) }}</div>
          </template>
          <template v-slot:cell(price)="data">
            <div>{{ formatRupiah(data.item.product.price) }}</div>
          </template>
          <template v-slot:cell(aksi)="data">
            <b-button @click="$router.push(`/show-pengajuan-lending/${data.item.funder.id}/${data.item.id}`)" type="button" variant="primary" class="btn btn-custom theme-color  rounded-5">
                Detail
            </b-button>
            <b-button v-if="data.item.status_pengajuan.code == 'PS03'" @click="changeStatus(data.item)" type="button"
              variant="success" class="btn btn-custom theme-color rounded-5 success">
              Setujui
            </b-button>
            <b-button v-if="data.item.status_pengajuan.code == 'PS03'" @click="rejectStatus(data.item)" type="button"
              variant="danger" class="btn btn-custom theme-color rounded-5 cancel">
              Tolak
            </b-button>
            <b-modal size="m" v-model="confirmStatusModal">
              <div class="d-block text-center">
                <h3>{{ modalTitle }}</h3>
              </div>
              <template #modal-footer>
                <div v-if="changingStatus" class="text-center">
                  <b-spinner variant="primary"></b-spinner>
                </div>
                <div v-else>
                  <b-button @click="confirmStatusModal = false" variant="danger">Tutup</b-button>
                  <b-button @click="confirmChangeStatus(data.item)" variant="primary">Ya</b-button>
                </div>
              </template>
            </b-modal>

            <b-modal size="md" v-model="confirmRejectStatusModal">
              <div class="d-block text-center">
                <!-- Judul Modal -->
                <!-- <h3 class="font-weight-bold text-primary mb-3 mt-0">Konfirmasi Penolakan</h3>
                <p class="text-secondary mb-4">
                  Anda akan menolak pengajuan ini. Silakan masukkan alasan penolakan di bawah ini.
                </p> -->
                <h3>{{ modalTitle }}</h3>
                <!-- <h4>{{ textModal }}</h4> -->
              </div>

              <template #modal-footer>
                <div v-if="changingStatus" class="text-center">
                  <b-spinner variant="primary"></b-spinner>
                </div>
                <div v-else>
                  <b-button @click="confirmRejectStatusModal = false" variant="danger">Tutup</b-button>
                  <b-button @click="rejectStatusConfirm" variant="primary">Ya</b-button>
                </div>
              </template>
            </b-modal>
          </template>
        </b-table>
      </div>

        <h2 v-if="!loaded" class="text-center"><b-spinner variant="warning"></b-spinner></h2>
        <b-pagination align="center" :total-rows="rowsPengajuan" :per-page="perPagePengajuan" aria-controls="pengajuan-table" v-model="currentPagePengajuan"></b-pagination>
    </div>

    <b-modal size="m" v-model="successModal">
      <div class="d-block text-center">
        <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
        <h3>Status berhasil diubah</h3>
      </div>
      <template #modal-footer>
        <div v-if="changingStatus" class="text-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <div v-else>
          <b-button @click="successModal = false" variant="primary">Tutup</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="m" v-model="rejectModal">
      <div class="d-block text-center">
        <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
        <h3>Pengajuan berhasil ditolak</h3>
      </div>
      <template #modal-footer>
        <div v-if="changingStatus" class="text-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <div v-else>
          <b-button @click="rejectModal = false" variant="primary">Tutup</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Pengajuan from '../../api/pengajuan.js';
import moment from 'moment';
import 'moment/locale/id'; // locale bahasa Indonesia

const pengajuanFields = [
  {
    key: 'id_transaksi',
    label: 'ID Transaksi',
    sortable: false
  },
  {
    key: 'funder',
    label: 'Nama Nasabah',
    sortable: true
  },
  {
    key: 'product',
    label: 'Nama Produk',
    sortable: true
  },
  {
    key: 'sub_product_category',
    label: 'Sub Kategori',
    sortable: true
  },
  {
    key: 'product.brands.name',
    label: 'Merk',
    sortable: true
  },
  {
    key: 'product.sub_brands.name',
    label: 'Sub Merk',
    sortable: true
  },
  {
    key: 'price',
    label: 'Harga',
    sortable: true
  },
  {
    key: 'created_at',
    label: 'Diajukan Pada',
    sortable: true
  },
  {
    key: 'aksi',
    label: 'Aksi',
  },
]

export default {
  name: "ManajemenPengajuanLending",

  data() {
    return {
      pengajuanItems: [],
      pengajuanFields: pengajuanFields,
      perPagePengajuan: 5,
      produk_id: '',
      pengajuan_id: '',
      currentPagePengajuan: 1,
      confirmDeleteModal: false,
      loaded: false,
      confirmRejectStatusModal: false,
      confirmStatusModal: false,
      successModal: false,
      modalTitle: '',
      changingStatus: false,
      rejectModal: false,
      textModal: '',
      isLoading: false,
    }
  },

  computed: {
    rowsPengajuan() {
      return Array.isArray(this.pengajuanItems) ? this.pengajuanItems.length : 0;
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      Pengajuan.pengajuanLendingMasukMitra()
        .then(res => {
          // console.log("respon res : ", res);
          this.pengajuanItems = res.data.data.data;
          this.loaded = true;
        })
        .catch(err => console.log(err));
    },
    formatTanggal(tanggal) {
      return moment(tanggal).locale('id').format('DD MMMM YYYY');
    },
    formatRupiah(angka) {
      if (typeof angka !== 'number') {
        angka = parseFloat(angka);
      }
      if (isNaN(angka)) return '-';

      return 'Rp. ' + angka
        .toFixed(0)
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    changeStatus(item) {
      this.product_id = item.id;
      this.modalTitle = 'Apakah anda yakin ?';
      this.confirmStatusModal = true;
    },
    rejectStatus(item) {
      this.pengajuan_id = item.id;
      this.modalTitle = 'Apakah anda yakin akan menolak pengajuan ini ?';
      // this.textModal = 'Anda akan menolak pengajuan ini ?';
      this.confirmRejectStatusModal = true;
    },
    rejectStatusConfirm() {
      this.changingStatus = true;
      Pengajuan.rejectStatus(this.pengajuan_id)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.confirmRejectStatusModal = false;
            this.rejectModal = true;
            this.loadData();
          } else {
            console.log(res.data);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.changingStatus = false;
        });
    },
    confirmChangeStatus(item) {
      this.changingStatus = true;
      const data = {
        id: this.product_id
      }

      Pengajuan.approvePengajuanByMitraPendukung(this.product_id)
        .then(res => {
          // console.log("respon approve : ", res);
          if (res.data.meta.code === 200) {
            this.confirmStatusModal = false;
            this.changingStatus = false;
            this.successModal = true;
            this.loadData();
          } else {
            console.log(res.data);
            this.changingStatus = false;
          }
        })
        .catch(err => console.log(err));
    },
    downloadPengajuanMasukMitra() {
      this.isLoading = true;
      Pengajuan.downloadPengajuanMasukMitra()
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'pengajuan_masuk_mitra.csv');
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          console.error('Error downloading the file:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
};
</script>

<style scoped>
.overflow-auto {
  overflow-x: auto;
  /* Mengaktifkan scroll horizontal */
  white-space: nowrap;
  /* Mencegah pembungkusan teks */
}

.b-table {
  min-width: 800px;
  /* Sesuaikan dengan lebar minimal yang Anda inginkan */
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
.btn-disabled {
  background-color: #d5a031  !important;
  color: #ffffff !important;
  opacity: 1; /* Hilangkan efek transparan */
  cursor: not-allowed; /* Tetap tidak interaktif */
  pointer-events: none; /* Tidak bisa diklik */
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pengajuan-lending-masuk.vue